import React from 'react';
import { Layout } from 'antd';

import PageHeader from './page-header';
import { useStore } from './store';

import './cyber-security-training.less';
import './cyber-security-training.mobile.less';

interface IPageLayoutProps {
  pageName: string;
  noHeader?: boolean;
  pageClass?: string;
}

const PageLayout: React.FunctionComponent<IPageLayoutProps> = (props) => {
  const { page, language } = useStore();
  if (!page) {
    return <div>Loading...</div>;
  }
  const idToClass = (id: string) =>
    ({
      cybersecurity2024: 'general2024',
      'general-staff': 'cybersecurity2025',
      'general-staff-a': 'general-staff',
    }[id]);
  return (
    <div
      className={`cyber-security-training-page ${props.pageName} ${language} ${
        ['cybersecurity2024', 'general-staff', 'general-staff-a'].includes(
          props.pageClass as string
        )
          ? idToClass(props.pageClass as string)
          : props.pageClass
      } ${process.env.REACT_APP_DOMAIN}-page`}
    >
      <Layout>
        {props.noHeader !== undefined && props.noHeader ? null : <PageHeader />}
        <Layout.Content>{props.children}</Layout.Content>
      </Layout>
    </div>
  );
};

export default PageLayout;
